/* Positioning lives with the handle (block-gutter.module.css); the toolbar is only the drag source. */
.toolbar {
  display: flex;
  pointer-events: auto;
}

/* Ensure dragstart's event.target falls through to the button (which carries
 * data-block-id), so Plate's DndPlugin guard reliably sets isDragging. Without
 * this, grabbing the icon SVG directly leaves dragstart.target as the SVG,
 * isDragging stays false, and slate-react's default onDrop runs — splitting
 * the target text run. */
.toolbar svg {
  pointer-events: none;
}
